//remove all gaps, makes first letter Uppercase and text CamelCase
export const toTranslationKey = (text: string) => {
  if(!text) return ''
  
  return text.replace(/[\s_-]+(\w)/g, (match, p1) => {
    return p1.toUpperCase();
  }).replace(/^\w/, (match) => {
    return match.toUpperCase();
  }).replace(/ /g, '');
};

export const camelCaseToText = (value: string) => {
  const text = value.replace(/([A-Z])/g, ' $1').trim();
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export const cutString = (value: string, maxLength: number) => {

  const text = value
  if (!text || !text.length) return ''

  return ((text.length > maxLength) ? text.slice(0, (maxLength-3)) + '...' : text)
}

export function trimStringFields(data: any): any {
  Object.keys(data).forEach(key => {
    if (typeof data[key] === 'string') {
      data[key] = data[key].trim();
    }
  });
  return data;
}